import type { FC, PropsWithChildren } from 'react';
import { connect } from 'react-redux';

import type { CoreRootState } from '../../../store/CoreStore';

import type { HelpContextType } from './HelpContext';
import { HelpContext } from './HelpContext';
import type { MapContextToStore } from './mapStateToHelpContextProps';
import { mapStateToHelpContextProps } from './mapStateToHelpContextProps';

interface HelpContextProviderProps extends PropsWithChildren {
  value: HelpContextType;
}

interface WithCustomMapperProps {
  customStateToPropsMap: MapContextToStore;
}

const HelpContextProviderWrapper: FC<HelpContextProviderProps> = ({ value, children }) => {
  return <HelpContext.Provider value={value}>{children}</HelpContext.Provider>;
};

// let the HOC automatically infer complex type from redux connect function
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const withCustomMapper = (WrappedComponent: typeof HelpContextProviderWrapper) => {
  const mapStateToProps = (state: CoreRootState, ownProps: WithCustomMapperProps): { value: HelpContextType } => ({
    value: {
      ...mapStateToHelpContextProps(state),
      ...ownProps.customStateToPropsMap(state), // Use the custom mapper function from props
    },
  });

  return connect(mapStateToProps)(WrappedComponent);
};

export const HelpContextProviderConnected = withCustomMapper(HelpContextProviderWrapper);
